



































































/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import TableMixin from '@root/common/mixins/table';
// @ts-ignore hack
import TableWidthMixin from '@root/common/mixins/table-width';
// @ts-ignore hack
import { IAntColumn } from '@root/types/table';
// @ts-ignore hack
import { getEnumByParentId, editInfo } from '@/api/exception-management';

import moment from 'moment';
// import { IFieldInfoListItem } from '@/types/component'
// import Utils from '@/utils/common'
//import WatchValue from '@/mixins/watch-value'
@Component({
  components: {
    AddEditData: () => import('./add-edit-data.vue')
  }
})
export default class ManualToWrangle extends Mixins(TableMixin, TableWidthMixin) {
  isEdit: boolean = false;
  addEditvisible: boolean = false;
  tableData: any = [];
  provinceData: any = [
    { label: '手动抬杆原因', value: 'cp_order_hand_lift_record_lift_cause' },
    { label: '特殊放行原因', value: 'cp_order_special_record_release_cause' }
  ];
  parentId = 'cp_order_hand_lift_record_lift_cause';
  tableLoading: boolean = false;
  total = 0;
  dataLoading: boolean = false;
  dataForm = null;
  add() {
    this.isEdit = false;
    this.dataForm = null;
    this.addEditvisible = true;
  }
  hanleClose() {
    this.addEditvisible = false;
  }
  toEdit(row: any) {
    this.isEdit = true;
    this.showeditInfo(row.id);
  }
  handleOK() {
    this.addEditvisible = false;
    this.fetchTableData(true);
    this.$store.dispatch('dictionaries/fetchDictionary', { force: true });
  }
  // 回显数据
  async showeditInfo(id: any) {
    if (this.dataLoading) return;
    this.dataLoading = true;
    try {
      const res = await editInfo({ id });
      this.dataForm = res.data || {};
    } catch (e) {
      console.log(e);
    } finally {
      this.dataLoading = false;
      this.addEditvisible = true;
    }
  }
  //   切换搜索条件
  handleProvinceChange() {
    this.current = 1;
    this.fetchTableData();
  }
  moment = moment;
  created() {
    this.fetchTableData();
  }
  onSearch() {
    this.fetchTableData(true);
  }
  current = 1;
  pageSize = 10;
  totalPage: any;
  /**
   * 获取数据
   */
  //@ts-ignore
  async fetchTableData(reset: boolean = false) {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      //@ts-ignore
      const { status, msg, data = {} } = await getEnumByParentId({
        parentId: this.parentId,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { totalNum, currPage, pageSize, datas, totalPage } = data;
      // this.total = Number(totalNum) || 0
      this.tableData = data.datas || [];
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
      this.totalPage = totalPage - 0;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * 设置可选择时间
   * @param current
   */

  get tableColums(): IAntColumn[] {
    return [
      {
        title: '排序',
        width: 100,
        dataIndex: 'sequence'
        // customRender: (text: any, record: any, index: number) => {
        //   if (record.isTotal === true) {
        //     return ''
        //   }
        //   return `${(this.current - 1) * this.pageSize + index + 1}`
        // },
      },
      {
        title: '枚举编码',
        width: 100,
        dataIndex: 'code',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '枚举名称',
        width: 200,
        dataIndex: 'cnName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '类型',
        width: 100,
        dataIndex: 'type',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '状态',
        width: 100,
        dataIndex: 'status',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '备注',
        dataIndex: 'describes',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '创建时间',
        width: 240,
        dataIndex: 'createTime',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '修改时间',
        width: 240,
        scopedSlots: { customRender: 'text-ellipse' },
        dataIndex: 'updateTime'
      },

      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 90
      }
    ];
  }
}
